import UploadFilePreview from './upload-file-preview';

export default UploadFilePreview;
